module.exports = __webpack_public_path__ + "static/media/podavane_signal_narushenie.7e5a156e.pdf";